import React from "react";
import cn from "classnames";
import { Button, Modal } from "react-bootstrap";
import { FaPenSquare } from "react-icons/fa";

import { Input } from "ui/components";
import { useSelector } from "react-redux";
import _ from 'underscore';

const ListHorizontal = ({ title, content, className }) => {
  const c = cn(
    className ? className : "",
    "row py-1 mb-1 list-item m-0 align-items-start fsz-12 border-bottom"
  );

  return (
    <div className={c}>
      <div className="col-4 p-0 fsz-12">{title}</div>
      <div className="col-1 p-0 fsz-12">:</div>
      <div className="col-7 p-0 text-start title fsz-12">{content}</div>
    </div>
  );
};

const ShipmentList = ({ data, type, onChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [newData, setNewData] = React.useState(null);
  const [show, setShow] = React.useState(false);
  const [jobs, setJobs] = React.useState([]);
  const [shipmentItems, setItem] = React.useState(null);
  const [reason, setReason] = React.useState("");

  const handleChecklist = async (d, r) => {
    setJobs((prevJob) => {
      const matchingJob = prevJob.find((job) => job?.job_order_id === d?.id);

      const updatedStatus =
        matchingJob.status === "checked" ? "unchecked" : "checked";

      const updatedJobs = prevJob.map((job) =>
        job?.job_order_id === d?.id
          ? { ...job, status: r ? "unchecked" : updatedStatus, reason: r }
          : job
      );

      return updatedJobs;
    });
  };

  const handleItemChange = async () => {
    const payload = {};

    if (type === "delivered") {
      payload.item = {
        ...shipmentItems?.item,
        quantity_delivered: parseFloat(shipmentItems?.item?.quantity_delivered),
        reason,
      };
    } else {
      payload.item = {
        ...shipmentItems?.item,
        quantity: parseFloat(shipmentItems?.item?.quantity),
        reason,
      };
    }

    const matchingJobIndex = newData?.jobs.findIndex(
      (job) => job?.id === shipmentItems?.job_id
    );

    if (matchingJobIndex !== -1) {
      setNewData((prevData) => {
        const updatedDataJobs = [...prevData?.jobs];

        const updatedMatchingJob = {
          ...updatedDataJobs[matchingJobIndex],
          delivery_order: {
            ...updatedDataJobs[matchingJobIndex]?.delivery_order,
            shipment: {
              ...updatedDataJobs[matchingJobIndex]?.delivery_order?.shipment,
              items: [
                ...updatedDataJobs[matchingJobIndex]?.delivery_order?.shipment
                  ?.items,
              ],
            },
          },
        };

        updatedMatchingJob.delivery_order.shipment.items[
          shipmentItems?.item_key
        ] = {
          ...payload?.item,
        };

        updatedDataJobs[matchingJobIndex] = updatedMatchingJob;

        return {
          ...prevData,
          jobs: updatedDataJobs,
        };
      });

      setItem(null);
      setReason("");
      setShow(false);
    }
  };

  React.useEffect(() => {
    if (type === 'delivered') {
      _.each(data?.jobs, function(job) {
        _.each(job?.delivery_order?.shipment?.items, function(i) {
          i.reason = ''
          i.quantity_delivered = i.quantity
        })
      })
    }

    setNewData(data);
  }, [data]);

  React.useEffect(() => {
    if (newData === null) {
      return () => {};
    }

    let jobs = [];

    newData?.jobs?.forEach((result) => {
      const payload = {
        job_order_id: result.id,
        status: "checked",
        items: result?.delivery_order?.shipment?.items,
      };
      jobs.push(payload);
    });

    setJobs(jobs);
  }, [newData]);

  React.useEffect(() => {
    if (jobs?.length === 0) return () => {};

    let jb = [];

    jobs?.forEach((job) => {
      let obj = {
        job_order_id: job?.job_order_id,
        items: job?.items,
      };

      if (type === "delivered") {
        obj.items = job?.items;
      } else {
        obj.status = job?.status;
        if (job?.status === "unchecked") {
          obj.reason = job?.reason;
        }
      }

      jb.push(obj);
    });

    onChange(jb);
  }, [jobs]);

  return (
    <div className="mt-3">
      <div className="page-pretitle text-secondary mb-2"> Daftar Shipment </div>
      {newData?.jobs?.map((d, i) => {
        const matchingJob = jobs.find((job) => job?.job_order_id === d?.id);
        return (
          <div
            key={i}
            style={{
              borderBottom: "0.5px solid #202020",
            }}
            className="bg-white px-2 py-3 mb-3 rounded"
          >
            <label className="row mb-2">
              {type !== "delivered" && (
                <div className="col-1 fw-semibold" style={{ fontSize: 11 }}>
                  <input
                    type="checkbox"
                    onChange={() => handleChecklist(d)}
                    checked={matchingJob?.status === "checked" ? true : false}
                    style={{ transform: "scale(1.5)", marginTop: 5 }}
                  />
                </div>
              )}

              <div className="col-4">
                <div style={{ fontSize: 11 }} className="fw-semibold">
                  {d?.delivery_order?.shipment?.code}
                </div>
                <div style={{ fontSize: 9 }}>
                  ORD: {d?.delivery_order?.order?.code}
                </div>

                {d?.delivery_order?.shipment?.ref_code && (
                  <div style={{ fontSize: 9 }}>
                    REF: {d?.delivery_order?.shipment?.ref_code}
                  </div>
                )}
              </div>
              <div className="col-6">
                <div style={{ fontSize: 11 }} className="fw-semibold">
                  {d?.destination?.name}
                </div>
                <div style={{ fontSize: 9 }}>
                  {d?.destination?.region?.district_name},{" "}
                  {d?.destination?.region?.regency_name},{" "}
                  {d?.destination?.region?.province_name}
                </div>
              </div>
            </label>

            {matchingJob?.status === "checked" ? (
              <div className="">
                <div>
                  <div className="row bg-light border border-1 border-secondary mx-1">
                    <div
                      className={cn(
                        "text-center fw-semibold border-end border-secondary p-2",
                        type === "delivered" ? "col-6 " : "col-8 "
                      )}
                    >
                      Nama Barang
                    </div>
                    <div
                      className={cn(
                        "text-center fw-semibold p-2",
                        type === "delivered"
                          ? "col-3 border-end border-secondary"
                          : "col-4 "
                      )}
                    >
                      QTY
                    </div>
                    {type === "delivered" && (
                      <div className={cn("text-center fw-semibold col-3 p-2")}>
                        QTY Terkirim
                      </div>
                    )}
                  </div>

                  {d?.delivery_order?.shipment?.items?.map((item, key) => (
                    <div
                      className="row border border-1 border-top-0 border-secondary mx-1"
                      key={key}
                      onClick={() => {
                        setItem({
                          item: item,
                          job_id: d?.id,
                          job_key: i,
                          item_key: key,
                        });
                        setShow(true);
                        setReason(item?.reason || "");
                      }}
                    >
                      <div
                        className={cn(
                          "text-center fw-semibold border-end border-secondary p-2",
                          type === "delivered" ? "col-6 " : "col-8 "
                        )}
                      >
                        {item?.item_name}

                        <div>
                          {StateForm?.errors[
                            `jobs.${i}.items.${key}.reason`
                          ] ? (
                            <div className="d-block invalid-feedback">
                              {
                                StateForm?.errors[
                                  `jobs.${i}.items.${key}.reason`
                                ]
                              }
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div
                        className={cn(
                          "text-center fw-semibold p-2 align-items-center justify-content-center d-flex",
                          type === "delivered"
                            ? "col-3 border-end border-secondary"
                            : "col-4 "
                        )}
                      >
                        {item?.quantity}{" "}
                        {type === "loading" && (
                          <FaPenSquare
                            className="ms-1"
                            size={15}
                            color="rgba(5,115,118,1)"
                          />
                        )}
                      </div>

                      {type === "delivered" && (
                        <div
                          className={cn(
                            "text-center fw-semibold p-2 align-items-center justify-content-center d-flex col-3 "
                          )}
                        >
                          {item?.quantity_delivered || 0}{" "}
                          {type === "delivered" && (
                            <FaPenSquare
                              className="ms-1"
                              size={15}
                              color="rgba(5,115,118,1)"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div>
                <label className="form-label required">Alasan</label>
                <div>
                  <textarea
                    className={cn(
                      "form-control bg-white fs-7",
                      StateForm?.errors[`jobs.${i}.reason`] ? "is-invalid" : ""
                    )}
                    onChange={(e) => handleChecklist(d, e?.target?.value)}
                  />

                  {StateForm?.errors[`jobs.${i}.reason`] ? (
                    <div className="d-block invalid-feedback">
                      {StateForm?.errors[`jobs.${i}.reason`]}
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </div>
        );
      })}

      <Modal
        show={show}
        onHide={() => {
          setItem(null);
          setReason("");
          setShow(false);
        }}
        backdrop="static"
        size="small"
        enforceFocus={true}
        dialogClassName="sc-modals"
      >
        <Modal.Header closeButton>
          <div className="fw-bold text-uppercase">Update Item</div>
        </Modal.Header>
        <Modal.Body className="bg-white">
          <div>
            <ListHorizontal
              title="Nama Item"
              content={shipmentItems?.item?.item_name}
            />

            {type === "delivered" && (
              <ListHorizontal
                title="Quantity"
                content={shipmentItems?.item?.quantity}
              />
            )}

            <ListHorizontal
              title={type === "delivered" ? "QTY Terkirim" : "Quantity"}
              content={
                <Input
                  type="number"
                  value={
                    type === "delivered"
                      ? shipmentItems?.item?.quantity_delivered
                      : shipmentItems?.item?.quantity
                  }
                  onChange={(e) =>
                    type === "delivered"
                      ? setItem({
                          ...shipmentItems,
                          item: {
                            ...shipmentItems?.item,
                            quantity_delivered: e?.target?.valueAsNumber,
                          },
                        })
                      : setItem({
                          ...shipmentItems,
                          item: {
                            ...shipmentItems?.item,
                            quantity: e?.target?.valueAsNumber,
                          },
                        })
                  }
                />
              }
            />

            <ListHorizontal
              title="Alasan"
              content={
                <div>
                  <textarea
                    className={cn(
                      "form-control bg-white fs-7",
                      StateForm?.errors[
                        `jobs.${shipmentItems?.job_key}.items.${shipmentItems?.item_key}.reason`
                      ]
                        ? "is-invalid"
                        : ""
                    )}
                    value={reason}
                    onChange={(e) => setReason(e?.target?.value)}
                  />

                  {StateForm?.errors[
                    `jobs.${shipmentItems?.job_key}.items.${shipmentItems?.item_key}.reason`
                  ] ? (
                    <div className="d-block invalid-feedback">
                      {
                        StateForm?.errors[
                          `jobs.${shipmentItems?.job_key}.items.${shipmentItems?.item_key}.reason`
                        ]
                      }
                    </div>
                  ) : null}
                </div>
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-white">
          <Button
            type="button"
            variant="primary"
            className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
            onClick={handleItemChange}
            disabled={StateForm?.loading}
          >
            Simpan
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ShipmentList;
